import styled from 'styled-components';
import { ListItemLink, Popup } from '../../styled/Popup.styled';
export const BrandshopPopup = styled(Popup) `
  width: 220px;
  right: 0;
`;
export const Badge = styled.div `
  font-size: 11px;
  line-height: 11px;
  border-radius: 12px;
  padding: 5px 8px;
  background-color: ${({ theme }) => theme.colorsV2.ui.general.primary};
  box-shadow: 2px 2px 6px ${({ theme }) => theme.colorsV2.grayscale.gray40};
  color: ${({ theme }) => theme.colorsV2.font.textWhite};
  display: flex;
  place-items: center;
`;
export const StyledLink = styled(ListItemLink) `
  font-size: ${({ theme }) => theme.fontSizes.sizeSm3};
  color: ${({ theme }) => theme.colorsV2.font.textPrimary};

  &:hover {
    text-decoration: none;
  }
`;
//# sourceMappingURL=BrandshopPopup.styled.js.map